import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';
import { DumpsterRentalsHeroSection } from '@trashlab/sitesapp/src/templates/redebins/components/dumpster-rentals/dumpster-rentals-hero-section';
import { DumpsterRentalsContent } from '@trashlab/sitesapp/src/templates/redebins/components/dumpster-rentals/dumpster-rentals-content';
import { ServiceAreasSection } from '@trashlab/sitesapp/src/templates/redebins/components/shared/service-areas-section';
import { ReadyWhenYouAre } from '@trashlab/sitesapp/src/templates/redebins/components/shared/ready-when-you-are';

const DumpsterRentalsPage = () => {
  return (
    <div>
      <DumpsterRentalsHeroSection />
      <DumpsterRentalsContent />
      <ReadyWhenYouAre />
      <ServiceAreasSection />
    </div>
  );
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/dumpster-rentals',
  component: DumpsterRentalsPage,
});

